export interface SparklineProps {
  values: readonly number[];
  width?: number;
  height?: number;
  stroke?: string;
  className?: string;
  title?: string;
}

/** Minimal inline SVG sparkline. No charting library. */
export function Sparkline({
  values,
  width = 120,
  height = 32,
  stroke = "var(--accent-cyan)",
  className,
  title,
}: SparklineProps) {
  if (values.length < 2) {
    return null;
  }

  const min = Math.min(...values);
  const max = Math.max(...values);
  const range = max - min || 1;
  const step = width / (values.length - 1);
  const points = values.map((value, index) => {
    const x = index * step;
    const y = height - ((value - min) / range) * height;
    return [x, y] as const;
  });
  const linePath = points
    .map(([x, y], index) => `${index === 0 ? "M" : "L"}${x.toFixed(1)},${y.toFixed(1)}`)
    .join(" ");
  const areaPath = `${linePath} L${width},${height} L0,${height} Z`;

  return (
    <svg
      className={className ? `sparkline ${className}` : "sparkline"}
      viewBox={`0 0 ${width} ${height}`}
      preserveAspectRatio="none"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
    >
      {title ? <title>{title}</title> : null}
      <path d={areaPath} fill={stroke} opacity="0.12" />
      <path
        d={linePath}
        fill="none"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinejoin="round"
        strokeLinecap="round"
      />
    </svg>
  );
}
